import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CachedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cached"}/>
}
